<div class="visitor-info-component" *ngIf="hospitalVisitorRestrictions && hospitalVisitorRestrictions.length>0">
  <button id="hospitalVisitorRestrictionsBtn" class="accordion" (click)="toggleAccordian($event)">
    <span *ngIf="!accordianActive">
      <svg
        width="20px"
        height="20px"
        viewBox="-2 -2 24 24"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin"
        class="jam jam-plus-circle-f"
      >
        <path
          d="M11 11h4a1 1 0 0 0 0-2h-4V5a1 1 0 0 0-2 0v4H5a1 1 0 1 0 0 2h4v4a1 1 0 0 0 2 0v-4zm-1 9C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"
          fill="#0071c2"
        />
      </svg>
    </span>
    <span *ngIf="accordianActive">
      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12ZM8.25 11.25C7.83579 11.25 7.5 11.5858 7.5 12C7.5 12.4142 7.83579 12.75 8.25 12.75L15.75 12.75C16.1642 12.75 16.5 12.4142 16.5 12C16.5 11.5858 16.1642 11.25 15.75 11.25L8.25 11.25Z"
          fill="#0071c2"
        />
      </svg>
    </span>
    Hospital Visitor Restrictions
  </button>
  <div class="panel" id="hospitalVisitorRestrictionsPanel" *ngIf="accordianActive">
    <p [innerHTML]="hospitalVisitorRestrictions"></p>
  </div>
</div>
